import { StatusBadge, type Tone } from "@/components/ui/StatusBadge";
import type { WebhookEventStatus } from "@/types/ezyvet";

const TONES: Record<WebhookEventStatus, Tone> = {
  processed: "synced",
  queued: "discrepancy",
  ignored: "neutral",
  failed: "unbilled",
};

export function WebhookStatusBadge({ status }: { status: WebhookEventStatus }) {
  return <StatusBadge tone={TONES[status] ?? "neutral"}>{status}</StatusBadge>;
}
